import './App.css';
import Home from './components/Home/index'

function App() {
  return (
    <div >
      <Home/>
    </div>
  );
}

export default App;
